<template>
  <div class="appCen">
    <div class="iframeOuterDiv">
      <!-- <div class="hotRecommend_container">
        <el-breadcrumb>
          <el-breadcrumb-item class="all" :class="{current:active== -1}"   @click.native="gethisList('',-1)">全部</el-breadcrumb-item>
          <el-breadcrumb-item
            v-for="(item, index) in itemList"
            ::key="item.id"
            @click.native="gethisList(item.id,index)"
            :class="{current:active==index}"  
            >{{ item.name }}</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div> -->
      <div class="f-default-product">
        <div class="module-headline">
            我的应用
        </div>
        <div class="product-container">
            <!-- <div class="product-card" v-if="currentUserInfo.user_info.isAdmin == 1 || isopen">
              <img src="../../assets/images/kaoshi.jpg" alt="">
              <div class="product-card-item-wrap">
                <div class="card-name">HeroSim教师管理端</div>
                <div class="card-description">HeroSim教师管理端</div>
                <div class="WordsLink_word-wrap flex align-cen">
                   <div @click="openDet('')">去下载HeroSim<span class="icon-al-download"></span></div>
                     <div  class="mft" @click="openTeac">进入管理<span class="icon-al-cog-fill"></span></div>
                </div>
              </div>
            </div>
            <div class="product-card">
              <img src="../../assets/images/kaoshi.jpg" alt="">
              <div class="product-card-item-wrap">
                <div class="card-name">我的考试</div>
                <div class="card-description">在线考试</div>
                <div class="WordsLink_word-wrap flex align-cen">
                     <div @click="openMyexam">进入查看<span class="icon-al-search"></span></div>
                </div>
              </div>
            </div> -->
            <div class="product-card"  v-for="(item, index) in myAppList" :key="item.id">
                <img :src="item.thumb" alt="">
                <div class="product-card-item-wrap">
                    <div class="card-name">{{item.appName}}</div>
                    <div class="card-description">{{item.description}}</div>
                     <div class="WordsLink_word-wrap flex align-cen">
                        <div @click="openDet(item)" v-if="item.type == 1">去下载<span class="icon-al-download"></span></div>
                        <div @click="openDet(item)" v-if="item.type == 3">进入查看<span class="icon-al-search"></span></div>
                           <!-- <div @click="openDet(item)" v-if="item.type == 2">进入查看<span class="icon-al-search"></span></div> -->
                             <div  v-if="item.type == 2 && item.resourceUrl.includes('/teacheManage/dashboard')" @click="openTeac(item)">进入管理<span class="icon-al-cog-fill"></span></div>
                          <div  v-if="item.type == 2 && item.resourceUrl.includes('/myExam/testingCenter')" @click="openMyexam(item)">进入查看<span class="icon-al-edit"></span></div>
                         <div  v-if="item.type == 2 && !item.resourceUrl.includes('/myExam/testingCenter') && !item.resourceUrl.includes('/teacheManage/dashboard')" @click="openDet(item,'web')">立即查看<span class="icon-al-search"></span></div>
                    </div>
                </div>
            </div>
        </div>
         <div class="module-headline">
            未开通应用
        </div>
         <div class="product-container">
          <!-- <div class="product-card" v-if="currentUserInfo.user_info.isAdmin != 1 && !isopen">
              <img src="../../assets/images/kaoshi.jpg" alt="">
              <div class="product-card-item-wrap">
                <div class="card-name">HeroSim教师管理端</div>
                <div class="card-description">HeroSim教师管理端</div>
                <div class="WordsLink_word-wrap flex align-cen">
                   <div >暂无权限</div>
                </div>
              </div>
            </div> -->
         <div class="product-card"  v-for="(item, index) in unAuthAppList" :key="index">
                <img :src="item.thumb" alt="">
                <div class="product-card-item-wrap">
                    <div class="card-name">{{item.appName}}</div>
                    <div class="card-description">{{item.description}}</div>
                    <div class="WordsLink_word-wrap  flex align-cen" @click="openDet(item)" v-if="!item.resourceUrl ||  !item.resourceUrl.includes('/teacheManage/dashboard')">
                        去开通<span class="icon-al-shoppingcart"></span>
                    </div>
                     <div class="WordsLink_word-wrap  flex align-cen" v-else>
                        暂无权限
                    </div>
                </div>
            </div>
         </div>
      </div>
    </div>
  </div>
</template>
<script>
import LocaStorage from "../../utils/localstorage.js";
import { appCenter, classList,getCurrentUser} from "@/api/enterprise/index"; // 应用列表、产品分类列表、当前用户信息
export default {
  name: "appCen",
  data() {
    return {
      officialType:'',
      isopen:false,
      active:-1,
      itemList: [],
      allId:'',
      myAppList:[],
      unAuthAppList:[],
      bussID:'',
      currentUserInfo:{
        user_info:{},
        roleList:[]
      }
    };
  },
  created() {
     const businessInfo = LocaStorage.setAge().get('businessInfo')
     this.bussID = businessInfo.id
     this.officialType = LocaStorage.setAge().get('officialType')
     this.getUserInfo()
    this.gethisList('',-1)
  },
  methods: {
         // 获取当前用户信息
        getUserInfo(){
             getCurrentUser({
                id:this.bussID
              },'enterprise')
            .then(res => {
            this.currentUserInfo = res.data
            this.isopen = this.currentUserInfo.roleList.some(user => user.roleId == 1)
            })
        },
    // 打开考试中心
    openMyexam(data){
      this.$locaStorage.setAge().set('doExamHelpId',data.id)
       const newurl = this.$router.resolve({name: 'courseAllIndex', query: {businessId:this.bussID}})
       window.open(newurl.href,'_blank')
    },
    // 打开教师管理端
    openTeac(data){
       this.$locaStorage.setAge().set('tearchHelpId',data.id)
        const newurl = this.$router.resolve({name: 'dashboard', query: {}})
       window.open(newurl.href,'_blank')
    },
    // 打开未开通详情
    openDet(data,web){
      if(!web){
        let appId = data ? data.id : 'RASO20220930001'
     const newurl = this.$router.resolve({name: 'endowloadDetail', query: {id: appId,type:2}})
       window.open(newurl.href,'_blank')
      }else{
          window.open(data.resourceUrl,'_black')
      }
    },
    // 获取产品分类
    async gethisClass() {
      await classList({}, "enterprise", 1)
        .then((res) => {
          if (res.code == 0) {
            // console.log(res)
            this.itemList = res.data || [];
            //    this.fristId = res.data[0].id
          }
        })
        .catch((err) => {});
    },
     // 获取产品列表
        gethisList(id,index){
            appCenter({id:this.bussID,parentClassifyId:id,officialType:this.officialType},'enterprise')
            .then(res =>{
              this.active = index
                this.myAppList = res.data.myAppList || []
                this.unAuthAppList = res.data.unAuthAppList || []
            })
        },
  },
};
</script>
<style lang="scss" scoped>
.appCen {
  position: relative;
  .iframeOuterDiv {
    max-width: 1344px;
    margin: 0 auto;
    height: auto;
    min-height: auto;
    padding: 20px 32px 0;
    box-sizing: border-box;
    .hotRecommend_container {
      margin: 22px 0 30px;
      width: 100%;
      height: 22px;
      line-height: 22px;
      cursor: default;
      font-size: 0;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
    .f-default-product{
    display: block;
    width: 100%;
    height: auto;
    text-align: left;
    .module-headline{
    height: 44px;
    line-height: 24px;
    padding-bottom: 20px;
    color: #333;
    box-sizing: border-box;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 20px;
    position: relative;
    }
    .module-headline::before{
        content: "";
    position: relative;
    top: 5px;
    display: inline-block;
    vertical-align: top;
    margin-right: 8px;
    width: 4px;
    height: 16px;
    background: #2893f1;
    border-radius: 3px;
    }
    .product-container{
        margin-bottom: 4px;
        width: 100%;
      .product-card{
        width: calc((100% - 3 * 32px) / 4);
            position: relative;
            margin: 0 20px 20px 0;
            display: inline-block;
            vertical-align: top;
            max-width: 296px;
            min-width: 260px;
            background-color: #fff;
            box-shadow: 0 4px 20px rgba(19,19,51,0.04);
            border-radius: 4px;
            z-index: 1;
            font-size: 0;
            font-family: Microsoft YaHei;
            font-weight: 400;
            transition: box-shadow .15s;
            img{
                width: 100%;
                height: 150px;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
            }
            .product-card-item-wrap{
             padding: 12px 16px 16px;
             .card-name{
                width: 100%;
                margin-bottom: 2px;
                overflow: hidden;
                color: #161616;
                font-weight: 600;
                font-size: 16px;
                line-height: 26px;
                white-space: nowrap;
                text-overflow: ellipsis;
             }
             .card-description{
                display: -webkit-box;
                margin-bottom: 12px;
                overflow: hidden;
                color: #b4b7c1;
                font-size: 14px;
                line-height: 22px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
             }
             .WordsLink_word-wrap{
                color: #2893f1;
                font-size: 14px;
                line-height: 22px;
                cursor: pointer;
                span{
                        display: inline-block;
                    font-size: 13px;
                    margin-left: 4px;
                }
             }
            }
      }  
    }
    .appcennone{
    margin: 50px auto;
    width: 370px;
    height: 280px;
    .portal_def_icon{
      width: 350px;
      height: 206px;
    background: url('../../assets/images/shopOrderList_default.png') no-repeat 0 0;
    margin: 0 auto;
    }
    .portal_def_subHeadline{
      color: #90909e;
    font-size: 16px;
        display: block;
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 6px;
    }
    }
    }
  }
}
::v-deep {
  .all {
    .el-breadcrumb__inner {
     color: #888;
      background-color: #edeef2;
      position: relative;
      padding: 0 8px;
      text-align: center;
      border-radius: 2px;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .current{
    .el-breadcrumb__inner {
         background: #38f !important;
      color: #fff !important;
    }
  }
  .el-breadcrumb__item {
    .el-breadcrumb__inner {
      color: #888;
      background-color: #edeef2;
      position: relative;
      padding: 0 8px;
      text-align: center;
      border-radius: 2px;
      font-size: 12px;
      cursor: pointer !important;
      transition: background-color 0.15s, color 0.15s;
    }
  }
}
</style>